import React from 'react';
import Button from 'react-bootstrap/Button';
import Select from 'react-select';
import { FaPlus, FaFilter } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';

import KanbanPopup from '../kanban/KanbanPopup';
import Pages from '../list/Pagination';
import ExportFields from './ExportFieldListPopup';
import Util from '../../util/Util';
import Const from '../../util/Constants';
import Constants from '../../util/Constants';

class ListHeader extends React.Component {

  constructor(props) {
    super(props);
    this.pages = [ {value: '10', label: '10'}, {value: '25', label: '25'},
      {value: '50', label: '50'}, {value: '100', label: '100'}, {value: '200', label: '200'},
      {value: '500', label: '500'} ];
    let value = this.pages.find(page => parseInt(page.value) === parseInt(this.props.perPage));
    if(value === undefined) { 
      value = this.pages.find(page => parseInt(page.value) === 10);
      props.onPerPageChange('10');
    }

    this.state = { value: value, action: null, import: false, export: false, kanbanPopupVisible: false };
    this.user = reactLocalStorage.getObject(Const.LoggedInUser);
    const Import = Util.isAllow(props.model.permission, Const.PermImport);
    const Export = Util.isAllow(props.model.permission, Const.PermExport);
    const MassUpdate = Util.isAllow(props.model.permission, Const.PermMassUpdate);
    const MassMail = Util.isAllow(props.model.permission, Const.PermMassEmail);
    const MassSms = Util.isAllow(props.model.permission, Const.PermMassSMS);
    const MassWhatsApp = Util.isAllow(props.model.permission, Const.PermMassWhatsApp);
    const MassDelete = Util.isAllow(props.model.permission, Const.PermMassDelete);
    this.views = Const.VIEW_OPTIONS;
    this.actions = [];
    if(Import && this.props.import) {
      this.actions.push({ value: 'import', label: 'Import' });
    }
    if(Export && this.props.export) {
      this.actions.push({ value: 'export', label: 'Export' });
    }
    if(MassUpdate && this.props.showMassUpdate) {
      this.actions.push({ value: 'mass-update', label: 'Mass Update' });
    }
    if(MassMail && this.props.showMassEmail) {
      this.actions.push({ value: 'mass-email', label: 'Mass Email' });
    }
    if(MassSms && this.props.showMassSMS) {
      this.actions.push({ value: 'mass-sms', label: 'Mass SMS' });
    }
    if(MassWhatsApp && this.props.showMassWhatsApp) {
      this.actions.push({ value: 'mass-whatsapp', label: 'Mass WhatsApp' });
    }
    if(MassDelete) {
      this.actions.push({ value: 'mass-delete', label: 'Mass Delete' });
    }
  }

  onAction = action => {
    this.setState({ ...this.state, action: null });
    if(action && action.value === 'import') {
      this.props.import();
    } else if(action && action.value === 'export') {
      this.setState({...this.state, export: true});
    } else if(action && action.value === 'mass-update') {
      this.props.showMassUpdate();
    } else if(action && action.value === 'mass-email') {
      this.props.showMassEmail();
    } else if(action && action.value === 'mass-sms') {
      this.props.showMassSMS();
    } else if(action && action.value === 'mass-whatsapp') {
      this.props.showMassWhatsApp();
    } else if(action && action.value === 'mass-delete') {
      this.props.showMassDelete();
    }
   }

  onView = view => {
    reactLocalStorage.set(Const.View, view.value);
    this.props?.onModuleViewChange?.(view);
  }

  onChange = val => {
    this.setState({ ...this.state, value: val});
    this.props.onPerPageChange(val.value);
  }

  onKanbanPopupHide = () => this.setState({ ...this.state, kanbanPopupVisible: false });

  onKanbanCreate = (data) => {
    reactLocalStorage.setObject(Const.KanbanViews, { ...this.props.kanbanViews, [data.value]: data });
    this.props?.onKanbanViewsCreate?.(data);
    this.onKanbanPopupHide();
  }

  onKanbanViewChange = newView => {
    reactLocalStorage.setObject(Const.CurrentKanbanView, newView);
    this.props?.onKanbanViewChange?.(newView);
  }

  exportHide = () => this.setState({...this.state, export: false});
  export = fields => { this.exportHide(); this.props.export(fields); }

  render() {
    const pagination = this.props.pagination;
    const view = this.props.view;
    const kanbanViewsOptions = (this.props.kanbanViews ?? [])?.map(item => ({ value: item.id, label: item.name }));

    const isKanbanLead = view?.value === Const.KanbanView && this.props.model?.model_no === 1;
    const isGrowthAndAbovePackage = parseInt(this.user.package) >= Const.PackageGrowth;

    return (
      <>
        <ExportFields show={this.state.export} model={this.props.model}
          onHide={this.exportHide} onSubmit={this.export} />
        <div className="sectionlist pt-3">
          <div className="container-fluid">    
            <div className="row">  
            {!isKanbanLead ? (
              <div className="col-md-4">
                <div className="row">
                  <div className="col-md-9">
                    <Pages
                      current={pagination.currentPage}
                      end={pagination.pageCount}
                      onPageChange={this.props.onPageChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <Select
                      value={this.state.value}
                      options={this.pages}
                      onChange={this.onChange}
                    />
                  </div>
                </div>
              </div> ) : null
            }

            {!isKanbanLead && (
              <div className="col-md-2">
                <span className="btn btn-lead btn-sm">
                  Total : {this.props.listCount}
                </span>
              </div>
            )}
           
              <div className={isKanbanLead ? "col-md-12 d-flex justify-content-end" : "col-md-6"}>
                <div className="row filterrow">
                  <div className="col-md-12 lastcol">
                    {
                      view?.value === "kanban-view" ? (
                        <>
                          <div className="m-right">
                            <Select onChange={this.onKanbanViewChange} options={kanbanViewsOptions}
                              value={this.props.selectedKanbanView} />
                          </div>
                        </>
                      ) : null
                    }
                    {
                      this.props?.model?.model_no === Constants.Lead && isGrowthAndAbovePackage ? (
                        <div className="m-right">
                          <Select onChange={this.onView} options={this.views}
                            value={view} />
                        </div>
                      ) : null
                    }  
                    {!isKanbanLead ? (                  
                    <div className="m-right" onClick={this.props.toggleFilter}>
                      <div className="btn btn-lead btn-sm filter-button">
                        <FaFilter />
                        <span className="badge badge-danger badge-mini rounded-circle">
                          {this.props.filterCount}
                        </span>
                      </div>
                    </div> ): null }
                    <div className="m-right">
                      { this.props.add ?
                      <Button className="btn-sm btn-lead" onClick={this.props.onAddClick}>
                        <FaPlus /> Add
                      </Button>
                      : null }
                    </div>
                    <div className="m-right">
                      <Select onChange={this.onAction} options={this.actions}
                        value={this.state.action} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default ListHeader;